import _ from 'lodash';
import CryptoJS from 'crypto-js';

function camSafeUrlEncode(str) {
  return encodeURIComponent(str)
    .replace(/!/g, '%21')
    .replace(/'/g, '%27')
    .replace(/\(/g, '%28')
    .replace(/\)/g, '%29')
    .replace(/\*/g, '%2A');
}

function getObjectKeys(obj) {
  const list = [];
  Object.keys(obj).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      list.push(key);
    }
  });
  return list.sort((a, b) => {
    a = a.toLowerCase();
    b = b.toLowerCase();
    // eslint-disable-next-line no-nested-ternary
    return a === b ? 0 : a > b ? 1 : -1;
  });
}

function serialize(obj) {
  const arr = [];
  getObjectKeys(obj).forEach(key => {
    let val = obj[key];
    if (!val) {
      if (val === 0 || val === '0') {
        val = '0';
      } else {
        val = '';
      }
    }
    arr.push(`${camSafeUrlEncode(key).toLowerCase()}=${camSafeUrlEncode(val) || ''}`);
  });
  return arr.join('&');
}

// 获取调正的时间戳
function getSkewTime(offset) {
  return Date.now() + (offset || 0);
}

/**
 * @description 组合生成正确的 policy
 * @export
 * @param {*} params
 * {
 *    SecretId,
 *    keytime,
 *    Bucket,
 *    Prefix,
 *    action,
 *    files,
 * }
 * @return {*}
 */
export function generatePolicy(params) {
  const qKeyTime = params.keytime;
  const qSignAlgorithm = 'sha1';
  const conditions = [
    { bucket: params.Bucket },
    { action: params.action },
    { 'q-sign-algorithm': qSignAlgorithm },
    { 'q-sign-time': qKeyTime },
    { 'q-ak': params.SecretId },
  ];

  // 限定允许的前缀
  const limitPrefix = params.files.map(file => {
    const realKey = params.Prefix + file.name;
    if (file.isDir) {
      return ['starts-with', '$key', `${realKey}/`];
    }
    return ['eq', '$key', realKey];
  });

  conditions.push(...limitPrefix);

  const endtime = qKeyTime.split(';')[1];
  const policyStr = JSON.stringify({
    expiration: new Date(endtime * 1000).toISOString(),
    conditions,
  });

  const policy = Buffer.from(policyStr).toString('base64');
  return policy;
}

/**
 * @description 获取 policy 分享签名
 * @param {String} secretId
 * @param {Object} { signKey, policy }
 * @param {String} _method http请求方法: put/get/post/delete/head等
 * @param {Object} params
 * {
 *    SecretId,
 *    keytime,
 *    signKey,
 *    policy,
 *    method,
 *
 *    Query,
 *    Headers,
 *    Key,
 * }
 */
export function getPolicySign(params) {
  const signKey = params.signKey || '';
  const secretId = params.SecretId || '';
  const policy = params.policy || '';
  const method = (params.method || 'get').toLowerCase();
  // const queryParams = _.cloneDeep(params.Query || {});
  // const headers = _.cloneDeep(params.Headers || {});
  const queryParams = _.cloneDeep({});
  const headers = _.cloneDeep({});
  const Key = params.Key || '';
  let pathname;
  pathname = params.Pathname || params.pathname || Key;
  if (pathname.indexOf('/') !== 0) {
    pathname = `/${pathname}`;
  }

  if (!signKey) throw new Error('missing param signKey');
  if (!secretId) throw new Error('missing param secretId');
  if (!policy) throw new Error('missing param policy');

  const qSignAlgorithm = 'sha1';

  // 1.生成 KeyTime
  // 签名有效起止时间
  const now = Math.round(getSkewTime(params.SystemClockOffset) / 1000) - 1;
  let exp = now;

  const Expires = params.Expires || params.expires;
  if (Expires === undefined) {
    exp += 3600; // 签名过期时间为当前 +3600s
  } else {
    exp += Expires * 1 || 0;
  }
  const qKeyTime = `${now};${exp}`;
  const qSignTime = qKeyTime;
  // console.log(`生成 KeyTime: ${qKeyTime}`);

  // 2.生成 StringToSign
  const qHeaderList = getObjectKeys(headers)
    .join(';')
    .toLowerCase();
  const qUrlParamList = getObjectKeys(queryParams)
    .join(';')
    .toLowerCase();
  const formatString = [method, pathname, serialize(queryParams), serialize(headers), ''].join('\n');
  // console.log(`生成 formatString: ${formatString.toString()}`);

  const stringToSign = ['sha1', qSignTime, CryptoJS.SHA1(formatString).toString(), ''].join('\n');
  // console.log(`生成 stringToSign: ${stringToSign}`);

  // 3.生成 Signature
  const qSignature = CryptoJS.HmacSHA1(stringToSign, signKey).toString();
  // console.log(`生成 Signature: ${qSignature}`);

  const qAk = secretId;
  const qPolicy = policy;
  // 4.构造 Authorization
  const authorization = [
    `q-sign-algorithm=${qSignAlgorithm}`,
    `q-ak=${qAk}`,
    `q-sign-time=${qSignTime}`,
    `q-key-time=${qKeyTime}`,
    `q-header-list=${qHeaderList}`,
    `q-url-param-list=${qUrlParamList}`,
    `q-signature=${qSignature}`,
    `q-policy=${qPolicy}`,
  ].join('&');

  // console.log(`最终的签名 Authorization:${authorization}`);
  return authorization;
}
